export default "__VITE_ASSET__BAayV9F$__"